class JumpLinks {
    constructor(containerElement) {
        // elementos del DOM
        this.container = containerElement;
        this.aside = this.container.querySelector('.js-jump-links');
        this.openBtn = this.container.querySelector('.js-jump-links-toggle');
        this.content = document.querySelector('.c-jump-links-content');
        this.list = this.container.querySelector('.c-jump-links-aside__list');
        this.links = [];

        // estados internos
        this.sections = [];
        this.observer = null;

        this.handleContainerClick = this.handleContainerClick.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.init();
    }

    init() {
        this.buildSections();
        this.bindEvents();
        this.setupObserver();
    }

    // eventos para ui

    toggleMenu(isOpen) {
        this.aside?.classList.toggle('is-open', isOpen);
        this.openBtn?.setAttribute('aria-expanded', String(isOpen));
    }

    setActive(activeLink) {
        this.links?.forEach(link => link.classList.remove('is-active'));
        if (activeLink) activeLink.classList.add('is-active');
    }

    buildSections() {

        // si ya existe lis en la lista usar estos
        if (this.list.childElementCount) {
            const links = this.list.querySelectorAll('.js-jump-links-link');


            links.forEach((link) => {
                const id = link.href.match(/#.*/)?.[0];
                const section = document.querySelector(id);

                if (section) {
                    this.sections.push({
                        link,
                        section,
                        wasIntersecting: false
                    });
                    this.links.push(link);
                }
            })

        } else {
            // solo obtenemos los h con id
            const headings = this.content?.querySelectorAll(':is(h1, h2, h3, h4, h5)[id]');

            headings.forEach((heading) => {
                const id = heading.id;

                // creamos li
                const li = document.createElement('li');
                li.className = 'c-jump-links-aside__item';

                // caremos a
                const a = document.createElement('a');
                a.className = 'c-jump-links-aside__link js-jump-links-link';
                a.href = `#${id}`;
                a.textContent = heading.textContent.trim();

                // armamos listado
                li.appendChild(a);
                this.list.appendChild(li);

                // actualizamos el array de sections con su estado
                this.sections.push(
                    {
                        link: a,
                        section: heading,
                        wasIntersecting: false
                    }
                )

                // actualizamos array de links
                this.links.push(a);
            });
        }
    }

    bindEvents() {
        // manejo de clic de los jumplinks
        this.container.addEventListener('click', this.handleContainerClick);

        // manejo de los clics fuere del TOC
        document.addEventListener('click', this.handleDocumentClick);
    }

    // delegacion de eventos

    handleContainerClick(event) {
        const target = event.target;

        // abrir menu
        if (target.closest('.js-jump-links-toggle')) {
            event.preventDefault();
            this.toggleMenu(true);
        }
        // cerrar menu
        else if (target.closest('.c-jump-links-aside__button')) {
            event.preventDefault();
            this.toggleMenu(false);
        }
        // click enlaces
        else if (target.closest('.js-jump-links-link')) {
            this.toggleMenu(false);
        }
    }

    handleDocumentClick(event) {
        if (this.aside?.classList.contains('is-open') && !this.container.contains(event.target)) {
            this.toggleMenu(false);
        }
    }

    // scrollspy

    setupObserver() {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                // buscamos en nuestros estados el h2 actual que coincida 
                const match = this.sections.find(item => item.section === entry.target);
                if (!match) return;

                if (entry.isIntersecting) {
                    this.setActive(match.link);
                    match.wasIntersecting = true;
                }
                else {
                    // si el h2 esta desapreciendo por abajo (estamos haciendo scroll para arriba)
                    if (match.wasIntersecting && entry.boundingClientRect.top > 0) {
                        const index = this.sections.indexOf(match);
                        // si el h2 no es el primero activamos el enlace anterior
                        if (index > 0) {
                            this.setActive(this.sections[index - 1].link);
                        } else {
                            // si es el primero limpiamos los active
                            this.setActive(null);
                        }
                    }
                    // reiniciamos estado del h2 porque ya no esta intersecionando
                    match.wasIntersecting = false;
                }
            });
        }, {
            // hacemos que la zona de observacion sea desde arriba hasta un 15% del viewport
            rootMargin: '0px 0px -78% 0px',
            threshold: 0
        });

        this.sections.forEach(item => this.observer.observe(item.section));
    }
}

document.querySelectorAll('.c-jump-links-aside').forEach(container => new JumpLinks(container));